
import React, { useContext } from "react";
import { Navbar, Container, Nav, Image } from "react-bootstrap";
import { BoxArrowRight } from "react-bootstrap-icons";
import { PersonCircle } from "react-bootstrap-icons";
import { Dropdown } from "react-bootstrap";

import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import logo from "../images/cvv-nvbar.png";
import { UserContext } from "../jsx/UserContext";
import cdacLogo from '../images/cdac.png';
import meityLogo from '../images/meitylogo.png';
import amritaLogo from '../images/amritalogo.png';
import '../styles/NavbarComp.css';
// ✅ Import TopMenu
import TopMenu from "./TopMenu";

function NavbarComp1({ activeTab, setActiveTab }) {

//function NavbarComp1() {
  const navigate = useNavigate();
  const { userSession, setUserSession } = useContext(UserContext);

const handleLogoutClick = async () => {
  Swal.fire({
    title: "Are you sure?",
    text: "You will be logged out of your session.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, Logout",
    cancelButtonText: "Cancel",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        // 🔹 Call backend logout API
        const response = await fetch("/logout", {
          method: "POST",
          // headers: {
          //   "Content-Type": "application/json",
          //   Authorization: `Bearer ${userSession?.access_token}`,
          // },
        });
console.log("logout response",response)
        if (!response.ok) {
          throw new Error("Logout failed");
        }

        // ✅ Clear session
        setUserSession({ name: "", access_token: "" });

        Swal.fire({
          title: "Logged Out!",
          text: "You have been logged out successfully.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          navigate("/login", { replace: true });
        });
      } catch (error) {
        console.error("Logout error:", error);
        Swal.fire({
          title: "Error!",
          text: "Failed to log out. Please try again.",
          icon: "error",
          confirmButtonColor: "#3085d6",
        });
      }
    }
  });
};

  return (
//     <Navbar bg="light" expand="lg" fixed="top" className="shadow-sm py-3" role="navigation" aria-label="Main Navigation">
//       <Container className="d-flex flex-column">

//         <div className="d-flex flex-column flex-lg-row justify-content-between align-items-center w-100 gap-2">
//           <div className="d-flex align-items-center gap-2">
//             <div>
//               <a
//                 href="/dashboard"
//                 tabIndex={0}
//                 aria-label="Go to Dashboard page"
//                 onKeyDown={(e) => e.key === "Enter" && (window.location.href = "/dashboard")}
//               >
//                 <Image
//                   src={logo}
//                   alt="ChalaChithra Vaachana Logo"
//                   height="40"
//                 />
//               </a>
//             </div>

//           </div>

//  <div className="d-flex align-items-center mt-2 mt-lg-0" role="banner">
//   <div className="d-flex align-items-center gap-2" aria-label="Partner logos">
//     <Image src={meityLogo} alt="Ministry of Electronics and Information Technology logo" height="45" />
//     <Image src={amritaLogo} alt="Amrita Vishwa Vidyapeetham logo" height="45" />
//     <Image src={cdacLogo} alt="Centre for Development of Advanced Computing logo" height="45" />
//   </div>


  <>
  <div>
<Navbar
  // bg="light"
  bg="navbar"
  expand="lg"
  className="shadow-sm py-2 custom-navbar"
  sticky="top"
  collapseOnSelect
  role="navigation"
  aria-label="Main navigation"
>
  <Container fluid className="px-4 d-flex justify-content-between align-items-center">

    {/* Left: Clickable CCV Logo */}
    <Navbar.Brand
      role="link"
      tabIndex={0}
      aria-label="Go to ChalaChithra Vaachana home page"
      onClick={() => navigate("/dashboard")}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") navigate("/dashboard");
      }}
      className="d-flex align-items-center cursor-pointer"
    >
      <Image
        src={logo}
        alt="ChalaChithra Vaachana Logo"
        height="55"
        className="navbar-logo"
      />
      <span className="visually-hidden">ChalaChithra Vaachana Home</span>
    </Navbar.Brand>

    {/* Right side: Partner logos + user icon together */}
    <div className="d-flex align-items-center gap-3">

      {/* Partner Logos (always visible) */}
      <div
        className="d-flex align-items-center gap-3"
        role="group"
        aria-label="Partner organization logos"
      >
        <Image
          src={meityLogo}
          alt="Logo: Ministry of Electronics and Information Technology, Government of India"
          height="50"
          className="navbar-icon"
        />
        <Image
          src={cdacLogo}
          alt="Logo: Centre for Development of Advanced Computing (C-DAC)"
          height="50"
          className="navbar-icon"
        />
        <Image
          src={amritaLogo}
          alt="Logo: Amrita Vishwa Vidyapeetham University"
          height="50"
          className="navbar-icon"
        />
      </div>

      {/* User dropdown (always visible next to logos)
      <Dropdown
        align="end"
        role="navigation"
        aria-label="User menu"
      >
        <Dropdown.Toggle
          variant="link"
          id="dropdown-user"
          className="text-decoration-none text-dark p-0 d-flex align-items-center"
          aria-haspopup="true"
          aria-expanded="false"
          aria-label="Open user menu"
        >
          <PersonCircle
            size={28}
            color="#007bff"
            aria-hidden="true"
            focusable="false"
          />
          <span className="visually-hidden">User Menu</span>
        </Dropdown.Toggle>

        <Dropdown.Menu
          className="shadow-sm"
          role="menu"
          aria-label="User options"
        >
          <div className="px-3 py-2 border-bottom" role="presentation">
            <div className="fw-semibold" aria-label="User name">
              {userSession?.name || "Guest"}
            </div>
            <small className="text-muted" aria-label="User email">
              {userSession?.email || ""}
            </small>
          </div>

          <Dropdown.Item
            onClick={() => navigate("/profile")}
            role="menuitem"
            aria-label="Go to My Profile"
          >
            My Profile
          </Dropdown.Item>

          <Dropdown.Divider />

          <Dropdown.Item
            onClick={handleLogoutClick}
            className="text-danger fw-semibold"
            role="menuitem"
            aria-label="Logout"
          >
            <BoxArrowRight size={16} aria-hidden="true" /> Logout
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown> */}
    </div>
  </Container>
</Navbar>
</div>
 {/* ✅ Add TopMenu HERE */}
      <TopMenu active={activeTab} onSelect={setActiveTab} />
    </>

  );
}

export default NavbarComp1;
